import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

import product from '@/store/shared/product'
import discountsCharges from '@/store/shared/discounts'
import taxes from '@/store/shared/taxes'
import deliveryNotes from '@/store/shared/delivery-notes'
import inmobilizedData from '@/store/shared/inmobilizedData'
import officeFinancialExpenses from '@/store/shared/officeFinancialExpenses'

export default {
  namespaced: true,
  state () {
    return {
      key: undefined,
      quantity: null,
      orderSender: null,
      orderReceiver: null,
      observation: null,
      itemStartDate: null,
      itemEndDate: null,
      newLine: false
    }
  },
  getters,
  mutations,
  actions,
  modules: {
    product,
    discountsCharges,
    taxes,
    deliveryNotes,
    inmobilizedData,
    officeFinancialExpenses
  }
}
